@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&family=Roboto&display=swap);
@import '../../../../common/skin-quiz/global/global.scss';
@import './variable';
@import './screens/index.scss';

.ps-lightbox.ps-open {
  top: 0 !important;
}

.screen-wrapper.selfie_intro_screen aiba-selfie-intro-screen .selfie-grid-wrapper aiba-selfie-content .consent__checkbox .checkbox[type=checkbox]{
  left: 10px;
}
